import classnames from 'classnames'
import { useMatch } from 'react-router-dom'
import { useEnableAutoOtUI } from '@OpsWb/logic'

import Box from '~/core/Box'
import Link from '~/core/Link'
import {
    OPS_PRODUCTION_PATH,
    OPS_SCHEDULING_PATH,
    OPS_QUALITY_PATH,
    MFG_PARTNER_PATH,
} from '~/redux-modules/preferences'
import styles from '../styles.css'

export const PLACEMENT = 'top-nav'

const OPERATIONS_MENU = {
    scheduling: {
        name: 'scheduling',
        title: 'Scheduling',
        path: `${OPS_SCHEDULING_PATH}/unbundledProducts`,
    },
    production: {
        name: 'production',
        title: 'Production',
        path: `${OPS_PRODUCTION_PATH}/salesOrders`,
    },
    mfgPartner: {
        name: 'mfgPartners',
        title: 'Manufacturing Partners',
        path: `${MFG_PARTNER_PATH}`,
    },
    quality: {
        name: 'quality',
        title: 'Quality',
        path: `${OPS_QUALITY_PATH}`,
    },
}

export const OperationsMenu = () => {
    const shouldEnableAutoOtUI = useEnableAutoOtUI()
    const opsSchedulingMatchPath = useMatch(`${OPS_SCHEDULING_PATH}/*`)
    const opsProductionMatchPath = useMatch(`${OPS_PRODUCTION_PATH}/*`)
    const mfgPartnerMatchPath = useMatch(`${MFG_PARTNER_PATH}/*`)
    const opsQualityMatchPath = useMatch(`${OPS_QUALITY_PATH}/*`)

    return (
        <Box paddingLeft="4px">
            {!shouldEnableAutoOtUI && (
                <Link
                    to={OPERATIONS_MENU.scheduling.path}
                    name={OPERATIONS_MENU.scheduling.name}
                    placement={PLACEMENT}
                    data-test-target="open-scheduling-wb"
                    className={classnames(styles.link, styles.item, {
                        [styles.linkActive]: opsSchedulingMatchPath,
                    })}
                >
                    {OPERATIONS_MENU.scheduling.title}
                </Link>
            )}
            <Link
                to={OPERATIONS_MENU.production.path}
                name={OPERATIONS_MENU.production.name}
                placement={PLACEMENT}
                data-test-target="open-production-wb"
                className={classnames(styles.link, styles.item, {
                    [styles.linkActive]: opsProductionMatchPath,
                })}
            >
                {OPERATIONS_MENU.production.title}
            </Link>
            <Link
                to={OPERATIONS_MENU.mfgPartner.path}
                name={OPERATIONS_MENU.mfgPartner.name}
                placement={PLACEMENT}
                data-test-target="open-mfg-partner"
                className={classnames(styles.link, styles.item, {
                    [styles.linkActive]: mfgPartnerMatchPath,
                })}
            >
                {OPERATIONS_MENU.mfgPartner.title}
            </Link>
            <Link
                to={OPERATIONS_MENU.quality.path}
                name={OPERATIONS_MENU.quality.name}
                placement={PLACEMENT}
                data-test-target="open-quality-wb"
                className={classnames(styles.link, styles.item, {
                    [styles.linkActive]: opsQualityMatchPath,
                })}
            >
                {OPERATIONS_MENU.quality.title}
            </Link>
        </Box>
    )
}

export default OperationsMenu
